import type { LeadFlow, FlowStep, FlowBranding } from '@/data'
import { toFormData } from '@/utils/toFormData'
import api from '..'

export interface LeadFlowPayload {
  name: string
  slug: string
  template_slug: string
  steps: FlowStep[]
  chat_id: number | null
  pixel_ids: number[]
  downsell_id: number | null
  brand?: FlowBranding
}

export function buildFlowFormData(payload: LeadFlowPayload): FormData {
  return toFormData(payload as unknown as Record<string, unknown>)
}

export async function createFlow(payload: LeadFlowPayload): Promise<LeadFlow> {
  const fd = buildFlowFormData(payload)
  const res = await api.post('/flows', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return res.data.data
}
